import React from 'react';
import { uxProjects } from '../data/projectsData';

const num = (i) => String(i + 1).padStart(2, '0');

const toParagraphs = (description) =>
  Array.isArray(description) ? description : [description];

export default function UXProjects() {
  return (
    <section id="ux-projects" className="py-[clamp(48px,9vw,84px)]" aria-labelledby="ux-projects-heading">
      <h2
        id="ux-projects-heading"
        className="mb-2 block font-extrabold uppercase tracking-[-0.01em] text-[32px] text-[#FBF0DC]/80"
      >
        UX Projects
      </h2>
      {uxProjects.map((project, i) => (
        <article
          key={project.title}
          className="grid grid-cols-1 items-start gap-x-[clamp(24px,4vw,56px)] gap-y-4 border-t-2 border-[#FBF0DC]/35 py-[clamp(28px,5vw,42px)] sm:grid-cols-[minmax(44px,110px)_minmax(220px,320px)_minmax(0,1fr)]"
        >
          <p className="m-0 font-extrabold text-[15px]">{num(i)}</p>
          <figure className="m-0">
            <img
              src={project.image}
              alt={project.title}
              loading="lazy"
              className="mx-auto block h-auto w-auto max-h-[420px] max-w-full"
            />
          </figure>
          <div>
            <h3 className="m-0 mb-2.5 font-extrabold tracking-[-0.01em] text-2xl">{project.title}</h3>
            <div className="mb-3.5 max-w-[68ch] space-y-3 text-base leading-[26px] text-[#FBF0DC]/[0.78]">
              {toParagraphs(project.description).map((para, p) => (
                <p key={p} className="m-0">{para}</p>
              ))}
            </div>
            <div className="mb-3.5 flex flex-wrap gap-2">
              {project.tags.map((tag) => (
                <span key={tag} className="tag">{tag}</span>
              ))}
            </div>
            <div className="flex flex-wrap gap-5">
              {project.figmaLink && (
                <a className="proj-link" href={project.figmaLink} target="_blank" rel="noopener noreferrer">
                  View Figma Prototype →
                </a>
              )}
              {project.github && (
                <a className="proj-link" href={project.github} target="_blank" rel="noopener noreferrer">
                  GitHub →
                </a>
              )}
              {project.demo && (
                <a className="proj-link" href={project.demo} target="_blank" rel="noopener noreferrer">
                  Demo →
                </a>
              )}
            </div>
          </div>
        </article>
      ))}
    </section>
  );
}
